module.exports = __webpack_public_path__ + "img/e.a1b0a924.jpg";